"use client";

import type { ReactNode } from "react";

import { ChatLayout } from "@/shared/lib/layouts/ChatLayout";

/** Clean home surface — no bubble / orbit animations. */
export function HomePageBackground({ children }: { children: ReactNode }) {
  return (
    <div className="relative flex min-h-0 flex-1 flex-col overflow-hidden bg-[var(--page)]">
      <ChatLayout surface={false} className="relative z-10 min-h-0 flex-1 bg-transparent">
        {children}
      </ChatLayout>
    </div>
  );
}
